export default __webpack_public_path__ + "static/media/Code typing-rafiki.a46e7557.svg";